module.exports = __webpack_public_path__ + "img/212.c9fa6cd9.png";